import React, { Component } from 'react'
import SendToL2ApprovalModalUI from './SendToL2ApprovalModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class SendToL2ApprovalModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      successMsg: null,
      errorList: []
    }
  }

  onSubmit = () => {
    if (this.state.submitting) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitting: true
    })

    const loanId = this.props.loan.loanId

    // API call to send for L2 Approval
    RestApiUtils.post(
      this.props.context,
      `/api/disbursement-checklist/${loanId}/send-for-approval`,
      this.onSubmitCallback,
      null,
      null
    )
  }

  onSubmitCallback = (response) => {
    const errorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        errorList.push(error.message || error)
      })
    }

    this.setState({
      successMsg: response.success || response.message || null,
      errorList: errorList,
      submitting: false
    })

    // If successful, close modal after a brief delay
    if (errorList.length === 0 && response.success) {
      setTimeout(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess()
        } else {
          this.props.onCancelClick()
        }
      }, 1500)
    }
  }

  render() {
    const { submitting, successMsg, errorList } = this.state

    return (
      <SendToL2ApprovalModalUI
        title="Send for L2 Approval"
        onSubmitClick={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        submitting={submitting}
      >
        {successMsg && (
          <div style={{
            color: 'green',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#d4edda',
            borderRadius: '4px',
            border: '1px solid #c3e6cb'
          }}>
            {successMsg}
          </div>
        )}

        {errorList.length > 0 && (
          <div style={{
            color: '#721c24',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#f8d7da',
            borderRadius: '4px',
            border: '1px solid #f5c6cb'
          }}>
            <strong>Error(s):</strong>
            <ul style={{ marginTop: '5px', marginBottom: '0', paddingLeft: '20px' }}>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        {!successMsg && (
          <p style={{ marginBottom: '10px' }}>
            Are you sure you want to send this disbursement checklist for L2 Approval?
          </p>
        )}

        {this.props.loan && (
          <div style={{
            fontSize: '13px',
            color: '#6c757d',
            marginTop: '10px',
            padding: '8px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px'
          }}>
            <strong>Loan:</strong> {this.props.loan.accountName} {this.props.loan.loanName || ''}
            <br />
            <strong>Loan ID:</strong> {this.props.loan.loanId}
          </div>
        )}
      </SendToL2ApprovalModalUI>
    )
  }
}

export default SendToL2ApprovalModalSF